module.exports = __webpack_public_path__ + "static/media/banner-contact.b9186e02.svg";